/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive200,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive401,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive500,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactivePathParams,
  GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryResponse,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive.ts";

export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactivePathParamsSchema =
  z.object({
    discountTypeId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactivePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive200Schema =
  z.boolean() as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive500>;

export const getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactive200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentEditorsDiscountTypesDiscounttypeidRetroactiveQueryResponse>;
